import { USER_INFORMATION, REMOVE_USER_INFORMATION } from '../mutation-types'

const state = {
    user: {}
}
  
  const mutations = {
    [USER_INFORMATION] (state, user) {
      state.user = user;
    },
    [REMOVE_USER_INFORMATION] (state)  {
      state.user = {}
    }
  }
  
  export default {
    state,
    mutations
  }